const TextEditor = () => {
	// if (props.type === 'multilineTextEditor') {
	// 	return null;
	// }
    return null;
};

export default TextEditor;
